export const keys = {
    test1: "1",
    test2: "2",
    OpenWeatherMap: '735bb800e75cbbe8c6a8c89b0c001734'
}